import formatGroupedValues from "../utils/formatGroupedValues";
import capitalizeFilterLabel from "../utils/capitalizeFilterLabel";
import React from "react";
import FilterField from "../fields/FilterField";
import FilterMultiSelect from "../fields/FilterMultiSelect";
import FilterSelect from "../fields/FilterSelect";
import FilterToggle from "../fields/FilterToggle";

export const CLIENT_FILES_SORT_OPTIONS = [
  { value: "name", label: "Name" },
  { value: "status", label: "Status" },
  { value: "type", label: "Type" },
  { value: "expiry", label: "Expiry" },
];

export const CLIENT_FILE_TYPE_OPTIONS = [
  { value: "object-pdf", label: "Object PDF" },
  { value: "sin-document", label: "SIN Document" },
  { value: "identity-document", label: "Identity Document" },
  { value: "resume-and-other", label: "Resume and Other" },
];

export const CLIENT_FILE_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "pending-review", label: "Pending Review" },
];

export const CLIENT_FILES_DEFAULT_FILTERS = {
  fileTypeFilters: [],
  statusFilters: [],
  showDeleted: false,
  sortBy: "name",
  sortDirection: "asc",
};

export function buildClientFilesFilterChips({
  fileTypeFilters = [],
  statusFilters = [],
  showDeleted,
}) {
  const chips = [];
  if (fileTypeFilters.length > 0) {
    const labelFor = (v) =>
      CLIENT_FILE_TYPE_OPTIONS.find((o) => o.value === v)?.label || v;
    chips.push({
      id: "types",
      key: "fileTypeFilters",
      fieldId: "files-type",
      label: `Type: ${formatGroupedValues(fileTypeFilters, labelFor, 3)}`,
    });
  }
  if (statusFilters.length > 0) {
    chips.push({
      id: "status",
      key: "statusFilters",
      fieldId: "files-status",
      label: `Status: ${formatGroupedValues(statusFilters, capitalizeFilterLabel, 3)}`,
    });
  }
  if (showDeleted) {
    chips.push({
      id: "deleted",
      key: "showDeleted",
      fieldId: "files-show-deleted",
      label: "Show Deleted",
    });
  }
  return chips;
}

function FieldWrapper({ fieldId, label, focusedFieldId, onFocusClear, children }) {
  return (
    <FilterField
      id={fieldId}
      label={label}
      focusedFieldId={focusedFieldId}
      onFocusClear={onFocusClear}
    >
      {children}
    </FilterField>
  );
}

export default function ClientFilesFilterFields({
  focusedFieldId,
  onFocusClear,
  fileTypeFilters = [],
  setFileTypeFilters,
  statusFilters = [],
  setStatusFilters,
  sortBy = "name",
  setSortBy,
  sortDirection = "asc",
  setSortDirection,
  showShowDeleted = false,
  showDeleted = false,
  setShowDeleted,
}) {
  return (
    <>
      <FieldWrapper
        fieldId="files-type"
        label="Type"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterMultiSelect
          id="files-type"
          options={CLIENT_FILE_TYPE_OPTIONS}
          value={fileTypeFilters}
          onChange={setFileTypeFilters}
          placeholder="Select…"
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="files-status"
        label="Status"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterMultiSelect
          id="files-status"
          options={CLIENT_FILE_STATUS_OPTIONS}
          value={statusFilters}
          onChange={setStatusFilters}
          placeholder="Select…"
        />
      </FieldWrapper>

      {showShowDeleted ? (
        <FilterToggle
          id="files-show-deleted"
          label="Show Deleted"
          checked={showDeleted}
          onChange={setShowDeleted}
        />
      ) : null}

      <FieldWrapper
        fieldId="files-sort-by"
        label="Sort By"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="files-sort-by"
          value={sortBy}
          onChange={setSortBy}
          options={CLIENT_FILES_SORT_OPTIONS}
          placeholder={null}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="files-sort-direction"
        label="Sort Direction"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="files-sort-direction"
          value={sortDirection}
          onChange={setSortDirection}
          options={[
            { value: "asc", label: "Ascending" },
            { value: "desc", label: "Descending" },
          ]}
          placeholder={null}
        />
      </FieldWrapper>
    </>
  );
}
